import { render, staticRenderFns } from "./UserActionPiece.vue?vue&type=template&id=27901ddb&"
import script from "./UserActionPiece.vue?vue&type=script&lang=js&"
export * from "./UserActionPiece.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports